import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Api } from '../../../api';
import { errorToast, successToast, getFilterKey, isSuperAdmin } from '../../../utils/helper';
import Breadcrumb from '../../../component/common/Breadcrumb';
import Table from '../../../component/common/Table';
import Pagination from '../../../component/common/Pagination/Pagination';
import { Helmet } from 'react-helmet';
import {
  APPROVAL_STATUS_DROPDOWN,
  BREATHWORK_FILTER,
  PER_PAGE,
  STATUS_FOR_DROPDOWN
} from '../../../utils/constants';
import { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import SelectMenu from '../../../component/common/SelectMenu';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import Loader from '../../../component/common/Loader';
import Topbar from '../../PulseSurvey/Topbar';
import { breathworkPageData as pageData } from '../../../utils/pageContent';
import { FilterPanel, TableCard } from '../../../component/common/designSystem';

const pages = [{ name: pageData.pageTitle, href: '/breathwork/manage' }];

const PAGE_SIZE = 10;

/**
 * Drafts was a button that swapped the list out from under you with no sign
 * of which of the two you were looking at. It is a facet of the same list, so
 * it reads as a tab — the same treatment Users gives All / Active / Disabled.
 */
const CONTENT_TABS = [
  { label: 'All', value: 'list' },
  { label: 'Drafts', value: 'drafts' }
];

const draft_check = {
  name: 'Draft',
  value: 0
};

const Breathwork = (props) => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [breathworkList, setBreathworkList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const [adminNameList, setAdminNameList] = useState([]);
  const [sortOrder, setSortOrder] = useState(-1);
  const [sortBy, setSortBy] = useState('');
  const [selectedPerPage, setSelectedPerPage] = useState(PER_PAGE[0]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [filterQuery, setFilterQuery] = useState('');
  const [filterCriteria, setFilterCriteria] = useState({
    breathworkType: '',
    breathworkStatus: '',
    approvalStatus: '',
    ratings: '',
    breathworkCategory: ''
  });
  const [isDraftsOpen, setIsDraftsOpen] = useState(false);
  const handlePagination = (pageNumber, pageSize, searchKey, sortBy, sortOrder) => {
    handleFilterAdminList();
    setLoader(true);

    if (isDraftsOpen) {
      // Api.getBreathworkList(pageNumber, pageSize, searchKey, '&breathworkStatus=0', sortOrder).then(
      Api.getDraftBreathworksList(pageNumber, pageSize, searchKey, sortBy, sortOrder).then(
        (response) => {
          if (response?.data?.meta?.code === 1) {
            setCurrentPage(pageNumber);
            setBreathworkList(response?.data?.data);
            setTotalCount(response?.data?.meta?.totalRecords);
            setLoader(false);
          } else if (response?.data?.meta?.code === 0) {
            setCurrentPage(1);
            setBreathworkList([]);
            setTotalCount(0);
            setLoader(false);
            errorToast(response?.data?.meta?.message);
          } else {
            setLoader(false);
          }
        }
      );
      return;
    } else {
      Api.getBreathworkList(pageNumber, pageSize, searchKey, sortBy, sortOrder).then((response) => {
        if (response?.data?.meta?.code === 1) {
          setCurrentPage(pageNumber);
          setBreathworkList(response?.data?.data);
          setTotalCount(response?.data?.meta?.totalRecords);
          setLoader(false);
        } else if (response?.data?.meta?.code === 0) {
          setCurrentPage(1);
          setBreathworkList([]);
          setTotalCount(0);
          setLoader(false);
          errorToast(response?.data?.meta?.message);
        } else {
          setLoader(false);
        }
      });
    }
  };
  useEffect(() => {
    if (searchTerm) {
      let searchParam = searchTerm.trim();
      const delayDebounceFn = setTimeout(() => {
        handlePagination(1, PAGE_SIZE, searchParam, sortBy, sortOrder, 1);
      }, 800);

      return () => clearTimeout(delayDebounceFn);
    } else {
      if (props?.location?.state?.flag === 0) {
        filterHandler(draft_check, 'approvalStatus');
      } else {
        handlePagination(1, PAGE_SIZE, '', sortBy, sortOrder);
      }
    }
  }, [searchTerm, isDraftsOpen]);

  const deleteHandler = (id) => {
    setLoader(true);
    setSearchTerm('');
    Api.deleteBreathwork(id).then((response) => {
      if (response?.data?.meta?.code === 1) {
        handlePagination(1, PAGE_SIZE, '', sortBy, sortOrder);
        successToast(response?.data?.meta?.message);
      } else if (response?.data?.meta?.code === 0) {
        setLoader(false);
        errorToast(response?.data?.meta?.message);
      } else {
        setLoader(false);
      }
    });
  };
  const refreshTable = () => handlePagination(1, PAGE_SIZE, '', sortBy, sortOrder);
  const handleSortBy = (sortByValue) => {
    setSortBy(sortByValue);
    if (sortByValue === sortBy) {
      let tempSortOrder = sortOrder === 1 ? -1 : 1;
      setSortOrder(tempSortOrder);
      handlePagination(currentPage, PAGE_SIZE, searchTerm, sortByValue, tempSortOrder);
    } else {
      setSortOrder(1);
      handlePagination(currentPage, PAGE_SIZE, searchTerm, sortByValue, 1);
    }
  };
  const filterHandler = (data, key) => {
    setFilterCriteria((prevData) => ({
      ...prevData,
      [key]: data
    }));
    let clone = JSON.parse(JSON.stringify(filterCriteria));
    const newData = { ...clone, [key]: data };
    let tempFilterQuery = [];
    Object.keys(newData).forEach(function (key) {
      if (newData[key]?.value?.toString()) {
        tempFilterQuery.push(`&${key}=${newData[key]?.value}`);
      }
    });
    let query = tempFilterQuery?.toString()?.replaceAll(',', '');
    setFilterQuery(query);
    handlePagination(1, selectedPerPage.value, searchTerm, query, sortBy, sortOrder);
  };

  const resetHandler = () => {
    setFilterCriteria({
      accountType: '',
      affirmationStatus: ''
    });
    setFilterQuery('');
    setShowFilterModal(false);
    handlePagination(1, selectedPerPage.value, searchTerm, '', sortBy, sortOrder);
  };

  const handlePerPage = (perPage) => {
    setSelectedPerPage(perPage);
    handlePagination(1, perPage.value, searchTerm, filterQuery, sortBy, sortOrder);
  };

  const handleFilterAdminList = () => {
    Api.adminList().then((response) => {
      let adminList = response?.data?.data?.map((admin) => {
        return {
          value: admin.id,
          name: admin.name
        };
      });
      adminList = [pageData.adminList, ...adminList];
      setAdminNameList(adminList);
    });
  };
  /** Drives the count badge on Filter, so an applied filter is visible. */
  const activeFilterCount = Object.values(filterCriteria).filter((value) =>
    value?.value?.toString()
  ).length;

  const columns = [
    {
      title: pageData.tableHeaderText.listenAudio,
      key: 'audioUrl',
      type: 'play',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.breathworkName,
      key: isDraftsOpen ? 'breathworkName' : 'display_name',
      sortable: true,
      type: 'text',
      align: 'left',
      longText: true
    },
    {
      title: pageData.tableHeaderText.duration,
      key: 'duration',
      sortable: false,
      type: 'text',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.approvalStatus,
      key: 'approvalStatus',
      sortable: false,
      type: 'contentStatus',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.createdBy,
      key1: 'createdBy',
      key2: 'name',
      sortable: false,
      type: 'text',
      align: 'left',
      nested: true
    },
    {
      title: pageData.tableHeaderText.approvedBy,
      key1: 'approvedBy',
      key2: 'name',
      sortable: false,
      type: 'text',
      align: 'left',
      nested: true
    },
    {
      title: pageData.tableHeaderText.createdOn,
      key: 'createdOn',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.approvedOn,
      key: 'approvedOn',
      sortable: false,
      type: 'date',
      align: 'left'
    },
    {
      title: pageData.tableHeaderText.rating,
      key: 'rating',
      type: 'rating',
      align: 'center'
      // sortable: true,
    },
    {
      title: pageData.tableHeaderText.status,
      key: 'breathworkStatus',
      sortable: false,
      type: 'badge',
      align: 'left'
    },
    {
      title: '',
      key: 'action',
      type: isDraftsOpen ? 'draftAction' : 'action',
      align: 'right',
      isView: '/breathwork/manage/view',
      isEdit: '/breathwork/manage/add-edit',
      isDelete: true
    }
  ];

  return (
    <div className="relative">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{pageData.metaTitle}</title>
      </Helmet>
      {loader ? <Loader /> : null}
      <Topbar title={pageData.pageTitle} />
      <Breadcrumb pageList={pages} className="lg:mt-8" />
      <div className="lg:mt-6">
        <FilterPanel
          open={showFilterModal}
          onClose={() => setShowFilterModal(false)}
          onReset={resetHandler}
        >
          <div>
            <SelectMenu
              menuList={STATUS_FOR_DROPDOWN}
              defaultSelected={filterCriteria.focusStatus}
              label={pageData.filtersModal.statusLabel}
              isRequired={false}
              setSelectedMenu={(data) => filterHandler(data, 'breathworkStatus')}
            />
          </div>
          <div>
            <SelectMenu
              menuList={APPROVAL_STATUS_DROPDOWN}
              defaultSelected={filterCriteria.approvalStatus}
              label={pageData.filtersModal.approvalStatusLabel}
              isRequired={false}
              setSelectedMenu={(data) => filterHandler(data, 'approvalStatus')}
            />
          </div>
          {!isSuperAdmin() && (
            <div>
              <SelectMenu
                menuList={adminNameList}
                defaultSelected={filterCriteria.createdBy}
                label={pageData.filtersModal.createdByLabel}
                isRequired={false}
                setSelectedMenu={(data) => filterHandler(data, 'createdBy')}
              />
            </div>
          )}
          <div>
            <SelectMenu
              menuList={BREATHWORK_FILTER}
              defaultSelected={filterCriteria.breathworkCategory}
              label={pageData.filtersModal.breathworkCategory}
              isRequired={false}
              setSelectedMenu={(data) => filterHandler(data, 'breathworkCategory')}
            />
          </div>
          <div>
            <SelectMenu
              menuList={adminNameList}
              defaultSelected={filterCriteria.approvedBy}
              label={pageData.filtersModal.approvedByLabel}
              isRequired={false}
              setSelectedMenu={(data) => filterHandler(data, 'approvedBy')}
            />
          </div>
          {/* <div>
                <SelectMenu
                  menuList={RATING_DROPDOWN}
                  defaultSelected={filterCriteria.ratings}
                  label="Ratings"
                  isRequired={false}
                  setSelectedMenu={(data) => filterHandler(data, 'ratings')}
                />
              </div> */}
        </FilterPanel>

        <TableCard
          tabs={isSuperAdmin() ? CONTENT_TABS : []}
          activeTab={isDraftsOpen ? 'drafts' : 'list'}
          onTabChange={(value) => setIsDraftsOpen(value === 'drafts')}
          search={{
            value: searchTerm,
            onChange: (e) => setSearchTerm(e.target.value),
            placeholder: pageData.searchPlaceholder
          }}
          onFilter={() => setShowFilterModal((state) => !state)}
          filterCount={activeFilterCount}
          actions={
            /*
              Adding a breathwork has always been a choice of two kinds, so
              Add New opens a menu rather than navigating. It was a hand-rolled
              panel of two pill buttons closed by an outside-click hook; as a
              Headless UI Menu it dismisses and keyboard-navigates like every
              other menu in the panel.
            */
            <Menu as="div" className="relative flex">
              <Menu.Button className="btn-primary w-full sm:w-auto">
                {pageData.addNewBtnText}
                <ChevronDownIcon className="w-4 h-4" />
              </Menu.Button>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Menu.Items className="absolute right-0 top-full z-20 mt-2 w-56 origin-top-right rounded-btn bg-white dark:bg-shoorah-darkBgTabColor border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBorder shadow-lg focus:outline-none divide-y divide-shoorah-borderGray dark:divide-shoorah-darkBorder overflow-hidden">
                  {[
                    {
                      label: pageData.basicBreathworkBtnText,
                      href: '/breathwork/manage/add-edit?isBasicBreathwork=true'
                    },
                    {
                      label: pageData.normalBreathworkBtnText,
                      href: '/breathwork/manage/add-edit?isBasicBreathwork=false'
                    }
                  ].map((item) => (
                    <Menu.Item key={item.label}>
                      <button
                        type="button"
                        onClick={() => navigate(item.href)}
                        className="block w-full text-left px-4 py-3 text-sm text-shoorah-lightBlack dark:text-white hover:bg-shoorah-normanGray dark:hover:bg-shoorah-darkBgColor"
                      >
                        {item.label}
                      </button>
                    </Menu.Item>
                  ))}
                </Menu.Items>
              </Transition>
            </Menu>
          }
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: (page) =>
              handlePagination(
                page,
                selectedPerPage?.value,
                searchTerm,
                filterQuery,
                sortBy,
                sortOrder
              ),
            onPageSizeChange: (size) =>
              handlePerPage(PER_PAGE.find((o) => o.value === size) || PER_PAGE[0]),
            pageSizeOptions: PER_PAGE.map((o) => o.value)
          }}
        >
          <Table
            columns={columns}
            data={breathworkList}
            name={'breathwork_table'}
            setDeleteId={deleteHandler}
            bottomBorder={totalCount > PAGE_SIZE}
            setSortBy={(sort) => handleSortBy(sort)}
            contentType={3}
            addNewURL="/breathwork/manage/add-edit"
            refreshTable={refreshTable}
            loader={loader}
            setSearchTerm={(data) => setSearchTerm(data)}
          />
        </TableCard>
      </div>
    </div>
  );
};

Breathwork.propTypes = {
  location: PropTypes.any
};

export default Breathwork;
